module.exports = "pegasus_template/assets/themelp1/small/14.png";